import {IntegerInput, Switch} from 'platform/components';
import {Grid, GridItem, Show, VStack} from 'platform/foundation';

import {isNotNil} from 'ramda';

import {CompositionRectLayer} from '@dms/api/shared';
import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {ColorField} from './ColorField';

interface RectLayerFieldsProps extends TestIdProps {
  layer: CompositionRectLayer;
  onChange: (patch: Partial<CompositionRectLayer>) => void;
}

const DEFAULT_STROKE_COLOR = '#000000';
const DEFAULT_STROKE_WIDTH = 2;

export function RectLayerFields(props: RectLayerFieldsProps) {
  const stroke = props.layer.stroke;

  return (
    <VStack spacing={3}>
      <ColorField
        label={i18n.t('entity.watermark.composition.labels.fill')}
        value={props.layer.fill}
        onChange={(fill) => props.onChange({fill})}
        data-testid={suffixTestId('fill', props)}
      />
      <IntegerInput
        label={i18n.t('entity.watermark.composition.labels.radius')}
        value={props.layer.radius}
        minStepperValue={0}
        isStepperVisible
        onChange={(value) => props.onChange({radius: Math.max(0, value ?? 0)})}
        data-testid={suffixTestId('radius', props)}
      />
      <Switch
        label={i18n.t('entity.watermark.composition.labels.stroke')}
        value={isNotNil(stroke)}
        onChange={(isEnabled) =>
          props.onChange({
            stroke: isEnabled ? {color: DEFAULT_STROKE_COLOR, width: DEFAULT_STROKE_WIDTH} : null,
          })
        }
        data-testid={suffixTestId('strokeEnabled', props)}
      />
      <Show when={isNotNil(stroke)}>
        <Grid columns={2}>
          <GridItem>
            <ColorField
              label={i18n.t('entity.watermark.composition.labels.strokeColor')}
              value={stroke?.color ?? DEFAULT_STROKE_COLOR}
              onChange={(color) =>
                props.onChange({stroke: {width: stroke?.width ?? DEFAULT_STROKE_WIDTH, color}})
              }
              data-testid={suffixTestId('strokeColor', props)}
            />
          </GridItem>
          <GridItem>
            <IntegerInput
              label={i18n.t('entity.watermark.composition.labels.strokeWidth')}
              value={stroke?.width ?? DEFAULT_STROKE_WIDTH}
              minStepperValue={1}
              isStepperVisible
              onChange={(value) =>
                props.onChange({
                  stroke: {
                    color: stroke?.color ?? DEFAULT_STROKE_COLOR,
                    width: Math.max(1, value ?? 1),
                  },
                })
              }
              data-testid={suffixTestId('strokeWidth', props)}
            />
          </GridItem>
        </Grid>
      </Show>
    </VStack>
  );
}
